function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var f = Object.defineProperty,
    p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var t = function t(a, r, e) {
  return r in a ? f(a, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : a[r] = e;
},
    m = function m(a, r) {
  for (var e in r || (r = {})) {
    c.call(r, e) && t(a, e, r[e]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        g.call(r, e) && t(a, e, r[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
},
    i = function i(a, r) {
  return p(a, s(r));
};

import n, { forwardRef as y } from "react";
import B from "../lib/IconBase.mjs";
import b from "../defs/BabyCarriage.mjs";
var d = y(function (a, r) {
  return /* @__PURE__ */n.createElement(B, i(m({
    ref: r
  }, a), {
    weights: b
  }));
});
d.displayName = "BabyCarriage";
export { d as BabyCarriage };